module.exports = __webpack_public_path__ + "img/google.52a05e73.png";